import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useUpdateQuantityMutation } from '../../../../../store/newCart';
import { setLastQtyEditMethod, startLoading, stopLoading } from '../../../../../store/application';

import Icon from '../../../elements/icon';
import PriceTier from './pricingTier';
import Button from '../../../elements/button';
import { Modal, ModalBody } from '../../../elements/Modal';

import i18n from '../../../../../utils/translations/i18n';
import { RootState } from '../../../../../store';
import { TierPricesObject } from '../../../../../models/tiers';
import { tierSelectGaEvent } from '../../../../shopping-bag/ga-module';
import { get as getStorage, set as setStorage } from '../../../../../utils/storage/localStorage';
import { GaConstants } from '../../../../../enums/gaConstants';

export const SliderSingleQuantity = ({
  cart,
  lineItemId,
  isOpen,
  toggleModal

}) => {
  const { t } = i18n;
  const dispatch = useDispatch();
  const [updateSingleSelect] = useUpdateQuantityMutation();

  const { applicationState: { tierPricesData, lastQtyEditMethod } } = useSelector((state: RootState) => state);

  const mainItem: any = cart?.lineItems[lineItemId]?.[0]?.data;
  const tierDataForMainItem: TierPricesObject = tierPricesData[mainItem?.productKey] || [];
  const mainItemQuantity = mainItem?.quantity;
  const taxRate:number = mainItem?.taxRateWithName?.amount ?? 0;
  const [selectedQty, setSelectedQty] = useState(mainItemQuantity);
  const [isDisabled, setIsDisabled] = useState(false);
  const [sliderUnitPrice, setSliderUnitPrice] = useState<number | null>(null);
  const [sliderFreeQty, setSliderFreeQty] = useState<number | null>(null);

  const getTierPricesData =()=>{
    if(Number(tierDataForMainItem?.tierObject?.[0]?.quantity) === 1) {
      const tierPricesTemp = JSON.parse(JSON.stringify(tierDataForMainItem));
      tierPricesTemp?.tierObject.shift();
      tierPricesTemp?.oldPrices.shift();
      return tierPricesTemp;
    }
    return tierDataForMainItem;
  }

  const closeModal = () => {
    setSelectedQty(mainItemQuantity);
    toggleModal();
  };

  const saveAndUpdateCart = async () => {
    const tierData = {
      quantity: selectedQty,
      freeQuantity: sliderFreeQty,
      unitPriceWithoutCurrency: sliderUnitPrice,
    };

    tierSelectGaEvent(tierData, 0, false, mainItem, lastQtyEditMethod || GaConstants.SLIDER, cart?.fractionDigits);

    const gaSlideInfo = getStorage('qty-select-type');
    
    // Update the qtySelectType for the specific lineItemId
    if (gaSlideInfo[lineItemId] && lastQtyEditMethod) {
      gaSlideInfo[lineItemId]['qtySelectType'] = lastQtyEditMethod;
      setStorage('qty-select-type', gaSlideInfo);
      dispatch(setLastQtyEditMethod(''));
    }

    if (selectedQty !== mainItemQuantity) {
      dispatch(startLoading());
      updateSingleSelect({
        cartId: cart.id,
        lineItems: {
          data: {
            type: 'mainItem',
            attributes: {
              lineItemId: mainItem.id,
              quantity: selectedQty,
            },
          },
        },
      });
    } else {
      dispatch(stopLoading());
    }
    toggleModal();
  };

  const editBody = (
    <ModalBody>
      <section className='edit-quantity-modal-body'>
        <PriceTier
          tierPricesData={getTierPricesData()}
          selectedQty={selectedQty}
          setSelectedQty={(selectedQty) => setSelectedQty(selectedQty)}
          setIsDisabled={(isDisabled) => setIsDisabled(isDisabled)}
          setupCharge={mainItem.lineItemSetupCharge}
          setupChargeWithGlobalDiscount={
            mainItem.itemSetupChargeWithGlobalDiscount
          }
          setupChargeAdded={mainItem.setupChargeAdded}
          fractionDigits={cart.fractionDigits}
          taxRate={taxRate}
          mainItem={mainItem}
          setSliderUnitPrice={(price) => setSliderUnitPrice(price)}
          setSliderFreeQty={(qty) => setSliderFreeQty(qty)}
        />
      </section>
    </ModalBody>
  );

  const editFooter = (
    <>
      <div className='slider-btn'>
      <Button
        className='save-add-cart btn btn--large btn--full-width'
        onClick={saveAndUpdateCart}
        children={t('shopping_cart_details.saveAndUpdate')}
        isDisabled={isDisabled}
        style={{ textTransform:'none'}}
      />
      </div>
      <div className='error-edit-qty'>
        {' '}
        {t('shopping_cart_details.changeQtyError')}
      </div>
    </>
  );

  return (
    <>
      <Modal isOpen={isOpen} onClose={closeModal} customClass={"slider-modal"} className="qty-slider">
        <>
          <div className='modal-close'>
            <Icon
              icon='Close(Esc)'
              className='icon-cancel'
              onClick={closeModal}
            />
          </div>
          {editBody}
          {editFooter}
        </>
      </Modal>
    </>
  );
};
